import styled from 'styled-components'
import { groupNameColor } from '../../../constants/contentfulStyle.constant'

const customXSBreakpoint = 350

export const MinNavContainer = styled.main<{ $menuOpen: boolean }>`
  .MinNav__Overlay {
    position: fixed;
    display: block;
    z-index: 10;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.webMktNewPalette.black};
    opacity: 0.75;
  }

  .MinNav__Sidebar {
    position: ${({ $menuOpen }) => ($menuOpen ? 'relative' : 'fixed')};
    height: ${({ $menuOpen }) => ($menuOpen ? 0 : 69)}px;
    top: 0;
    width: 100%;
    z-index: 12;
    background-color: ${({ theme }) => theme.webMktNewPalette.white};
    padding-top: ${({ $menuOpen }) => ($menuOpen ? 0 : 10)}px;
    padding-bottom: ${({ $menuOpen }) => ($menuOpen ? 0 : 10)}px;
    ${({ theme }) => theme.breakpoints.down('xs')} {
      height: ${({ $menuOpen }) => ($menuOpen ? 0 : 42)}px;
    }
  }

  .MinNav__Logo {
    img {
      padding: 0px 16px;
      width: 148px;
      height: 69px;
    }
    img.desktop__logo {
      display: block;
    }
    img.mobile__logo {
      display: none;
    }
    ${({ theme }) => theme.breakpoints.down('xs')} {
      img {
        width: 104px;
        height: 42px;
      }
      img.desktop__logo {
        display: none;
      }
      img.mobile__logo {
        display: block;
      }
    }
  }
`

export const MinNavMenu = styled.div<{ $menuOpen: boolean }>`
  display: ${({ $menuOpen }) => ($menuOpen ? 'flex' : 'none')};
  flex-direction: column;
  width: 420px;
  position: absolute;
  right: 0px;
  top: 0px;
  background: ${({ theme }) => theme.webMktNewPalette.white};
  height: 100vh;
  overflow: auto;

  .MinNav__Header,
  .MinNav__Button_Wrapper {
    position: sticky;
    z-index: 20;
    top: 0;
    background: ${({ theme }) => theme.webMktNewPalette.white};
    margin: 10px 0;
  }

  .MinNav__Search_Text {
    cursor: pointer;
    padding: 0 24px;
    margin-top: 0;
    font-size: ${({ theme }) => theme.webMktTypography.fontSizes[4]};
  }

  .MinNav__Button_Wrapper {
    bottom: 0;
    width: 100%;
    margin-top: auto;
    padding-bottom: 24px;
    padding-top: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .MinNav__Button {
    width: calc(100% - 64px);
    margin: auto;
    display: flex;
    justify-content: center;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    width: 330px;
  }

  @media (max-width: ${customXSBreakpoint}px) {
    width: 100%;
  }
`

export const MinNavLinksWrapper = styled.ul`
  &--languageSwitcher {
    position: relative;
    padding-bottom: 16px;
  }

  .MinNav__Megamenu {
    display: none;
    .TopicIconLink {
      display: flex;
      align-items: flex-start;
      padding: 16px 24px 0;
      background-color: ${({ theme }) => theme.webMktNewPalette.background.light.accent};

      &:first-child {
        padding-top: 24px;
      }
      &:last-child {
        padding-bottom: 16px;
      }

      .Icon {
        margin-right: 8px;
        margin-top: 4px;
      }

      p {
        display: flex;
        align-items: center;
        margin: 0;
        font-size: ${({ theme }) => theme.webMktTypography.fontSizes[2]};
        font-weight: ${({ theme }) => theme.webMktTypography.fontWeights.semibold};
        span {
          background-color: ${({ theme }) => theme.webMktNewPalette.orange[50]};
          color: ${({ theme }) => theme.webMktNewPalette.white};
          font-weight: ${({ theme }) => theme.webMktTypography.fontWeights.semibold};
          font-size: ${({ theme }) => theme.webMktTypography.fontSizes[0]};
          padding: 0px 4px;
          border-radius: 2px;
          text-transform: uppercase;
          margin-left: 5px;
          display: inline-block;
          line-height: ${({ theme }) => theme.webMktTypography.lineHeights[1]};
          -webkit-text-stroke: 0px;
          letter-spacing: ${({ theme }) => theme.webMktTypography.letterSpacing.default};
        }
        .Navbar__SubList_IconLink {
          color: ${({ theme }) => theme.webMktNewPalette.black};
          &:hover {
            color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
          }
        }
      }

      &:hover {
        .Navbar__SubList_IconLink {
          p {
            color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
          }
        }
      }
    }
  }

  .MinNav__Accordion_All_Link {
    display: none;
    text-align: center;
    border-top: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[15]};
    padding: 16px 24px;

    a {
      color: ${({ theme }) => theme.webMktNewPalette.deepBlue[60]};
      font-weight: ${({ theme }) => theme.webMktTypography.fontWeights.regular};

      span {
        &.boldText {
          font-family: ${({ theme }) => theme.webMktTypography.fontFamilyName.poppins};
          color: ${({ theme }) => theme.webMktNewPalette.black};
          font-weight: ${({ theme }) => theme.webMktTypography.fontWeights.semibold};
        }
      }
      &:hover {
        color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
        span {
          &.boldText {
            color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
          }
        }
      }
    }
  }

  .MinNavLink__Active {
    .MinNav__Megamenu {
      display: flex;
      flex-direction: column;

      .Navbar__Sub_Accordion {
        &.NavLink__Active:first-child {
          .Navbar__Sub_Accordion_Item {
            .Navbar__Sub_Accordion_Name {
              &:before {
                content: '-';
              }
            }
          }
        }
        .Navbar__Sub_Accordion_Item {
          display: block;
          padding: 16px 24px;
          text-align: left;
          text-transform: none;
          background-color: ${({ theme }) => theme.webMktNewPalette.background.light.accent};
          border-bottom: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[15]};
          cursor: pointer;

          .Navbar__Sub_Accordion_Name {
            position: relative;
            font-weight: ${({ theme }) => theme.webMktTypography.fontWeights.semibold};

            &:before {
              content: '+';
              position: absolute;
              right: 0;
              width: 20px;
              height: 20px;
              font-size: ${({ theme }) => theme.webMktTypography.fontSizes[7]};
              font-weight: ${({ theme }) => theme.webMktTypography.fontWeights.regular};
              text-align: center;
            }
          }

          &.is-active {
            .Navbar__Sub_Accordion_Name {
              &:before {
                content: '-';
              }
            }
          }
        }
        .Navbar__Sub_Accordion_MenuGroup {
          display: none;
          background-color: ${({ theme }) => theme.webMktNewPalette.background.light.accent};
          .menu-tab-content {
            li {
              background-color: ${({ theme }) => theme.webMktNewPalette.background.light.accent};
            }
          }
          .Navbar__Sub_Accordion_Desc {
            display: none;
            padding: 16px 24px;
            ${({ theme }) => theme.breakpoints.down('xs')} {
              display: block;
            }
          }

          .Navbar__Sub_Accordion_All_Link {
            text-align: center;
            border-top: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[15]};
            padding: 24px 24px 32px;
            a {
              color: ${({ theme }) => theme.webMktNewPalette.black};
              font-weight: ${({ theme }) => theme.webMktTypography.fontWeights.regular};
              &:hover {
                color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
              }
            }
          }
        }
        &.NavLink__Active {
          display: block;
          height: 100%;
          .Navbar__Sub_Accordion_MenuGroup {
            display: flex;
            height: 100%;
            ${({ theme }) => theme.breakpoints.down('xs')} {
              flex-direction: column;
            }
          }
        }
      }
    }
    .MinNav__Accordion_All_Link {
      display: block;
      background-color: ${({ theme }) => theme.webMktNewPalette.background.light.accent};
    }
  }
`

export const MinNavLink = styled.li`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[15]};

  &:first-child {
    border-top: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[15]};
  }

  .Menu-item::before {
    right: 28px;
  }

  .Menu-item.is-active {
    background-color: unset;

    .MinNav__Link_Name {
      color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
    }

    &::before {
      border-color: ${({ theme }) => theme.webMktNewPalette.black};
    }
  }

  .MinNav__Link_Name {
    text-transform: capitalize;
    letter-spacing: ${({ theme }) => theme.webMktTypography.letterSpacing.narrow};
    width: 100%;
    font-size: ${({ theme }) => theme.webMktTypography.fontSizes[4]};
    text-align: left;
  }

  .MinNav__Dropdown_Button {
    width: 100%;
    padding: 16px 24px;
    text-align: right;
    display: flex;
    justify-content: space-between;
  }

  @media screen and (min-width: 1025px) {
    .Menu-item::before {
      content: '';
    }
  }
`

export const MinMegaMenuSection = styled.li<{ $textColor: string; $hasIconLink: boolean }>`
  padding: 10px 24px;
  background-color: ${({ theme }) => theme.webMktNewPalette.background.light.accent};
  display: ${({ $hasIconLink }) => ($hasIconLink ? 'block' : 'grid')};
  grid-template-rows: repeat(2, auto);
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 10px;

  .MinNav__Section_Content {
    grid-row: 1 / 2;
    grid-column: 1 / 3;
  }

  .MinNav__Section_Name {
    display: flex;
    align-items: center;
    letter-spacing: ${({ theme }) => theme.webMktTypography.letterSpacing.wide};
    margin-bottom: 12px;
    font-weight: ${({ theme }) => theme.webMktTypography.fontWeights.medium};
    font-size: ${({ theme }: any) => theme.webMktTypography.fontSizes[2]};
    color: ${({ $textColor }: any) => groupNameColor($textColor)};
    line-height: ${({ theme }) => theme.webMktTypography.lineHeights[3]};
    text-transform: uppercase;
    font-family: ${({ theme }) => theme.webMktTypography.fontFamilyName.inter};

    &:after {
      content: ' ';
      height: 1px;
      margin-left: 24px;
      flex: 2;
      background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[15]};
    }
  }

  .MinNav__Section_Description {
    margin-bottom: 16px;
    color: ${({ theme }) => theme.webMktNewPalette.deepBlue[55]};
  }
`

export const MinNavSubListItem = styled.li`
  margin-bottom: 10px;

  .MinNav__SubList_IconLink {
    display: block;
    margin-bottom: 16px;
  }

  .MinNav__IconLink_Header p,
  .MinNav__SubList_Cta p {
    font-weight: ${({ theme }) => theme.webMktTypography.fontWeights.semibold};

    span {
      background-color: ${({ theme }) => theme.webMktNewPalette.orange[50]};
      color: ${({ theme }) => theme.webMktNewPalette.white};
      font-weight: ${({ theme }) => theme.webMktTypography.fontWeights.semibold};
      font-size: ${({ theme }) => theme.webMktTypography.fontSizes[0]};
      padding: 0px 4px;
      border-radius: 2px;
      text-transform: uppercase;
      letter-spacing: ${({ theme }) => theme.webMktTypography.letterSpacing.default};
      margin-left: 5px;
      display: inline-block;
      line-height: ${({ theme }) => theme.webMktTypography.lineHeights[1]};
      -webkit-text-stroke: 0px;
    }
  }

  .MinNav__SubList_Cta:hover,
  .MinNav__SubList_IconLink:hover {
    p:first-child,
    .MinNav__IconLink_Header > p {
      color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
    }
  }

  .MinNav__IconLink_Header {
    display: flex;
    gap: 10px;
  }

  .MinNav__HighlightedLink {
    font-size: ${({ theme }) => theme.webMktTypography.fontSizes[2]};
    position: relative;
    bottom: 3px;
    color: ${({ theme }) => theme.webMktNewPalette.black};

    .CTA__Arrow-Container {
      margin-left: 8px;

      &::before {
        font-size: ${({ theme }) => theme.webMktTypography.fontSizes[3]};
      }
    }
  }
`

export const MinNavTopHatLinksWrapper = styled.ul`
  background-color: ${({ theme }) => theme.webMktNewPalette.background.light.accent};
  display: flex;
  justify-content: space-between;
  padding: 14px 0;
  border: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[15]};
  border-bottom: none;

  li {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 6px 0;
  }

  li:first-child {
    border-right: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[15]};
  }

  li:hover {
    p,
    img {
      color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
    }
  }

  a {
    display: flex;
    align-items: center;
    gap: 13px;

    p {
      font-weight: ${({ theme }) => theme.webMktTypography.fontWeights.semibold};
    }
  }
`

export const MinNavHamburger = styled.button<{ $menuOpen: boolean }>`
  position: absolute;
  top: ${({ $menuOpen }) => ($menuOpen ? 21 : 29)}px;
  right: 16px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: space-evenly;
  flex-flow: column nowrap;
  ${({ theme }) => theme.breakpoints.down('xs')} {
    top: ${({ $menuOpen }) => ($menuOpen ? 12 : 21)}px;
  }

  div {
    width: 20px;
    height: 2px;
    background-color: ${({ theme }) => theme.webMktNewPalette.black};
  }

  ${({ theme, $menuOpen }) => {
    return $menuOpen
      ? `
      right: 16px;

      &:hover {
        p {
          color: ${theme.webMktNewPalette.action.light.primary};
        }
      }

      div {
        width: 24px;
      }

      div:nth-child(1) {
        transform: translate(-1px, 7px) rotate(-315deg);
        top: 20px;
      }
  
      div:nth-child(2) {
        opacity: 0;
      }
  
      div:nth-child(3) {
        transform: translate(-1px, -6px) rotate(-225deg);
      }
    `
      : `
    `
  }}
`

export const MinNavLanguageSwitcher = styled.div`
  .LanguageSwitcher__Button {
    color: ${({ theme }) => theme?.webMktPalette?.grayCold[65]};
    font-size: ${({ theme }) => theme.webMktTypography.fontSizes[2]};
    font-weight: ${({ theme }) => theme.webMktTypography.fontWeights.regular};
    letter-spacing: ${({ theme }) => theme.webMktTypography.letterSpacing.default};
    line-height: ${({ theme }) => theme.webMktTypography.lineHeights[2]};
    margin-bottom: 16px;
  }

  .LanguageSwitcher__Button::after {
    width: 0px;
    height: 0px;
    transform: none;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid ${({ theme }) => theme?.webMktPalette?.grayCold[65]};
    border-bottom: none;
    content: '';
    position: absolute;
    left: 65px;
    top: 8px;
  }

  .LanguageSwitcher__List {
    display: none;
    background-color: ${({ theme }) => theme.webMktNewPalette.deepBlue[10]};
  }

  .LanguageSwitcher__List.is-active {
    margin-bottom: 32px;
  }

  .LanguageSwitcher__ListItem {
    padding: 10px 10px 9px 24px;

    a {
      font-size: ${({ theme }) => theme.webMktTypography.fontSizes[2]};
      color: ${({ theme }) => theme.webMktNewPalette.black};
      display: inline-block;
      vertical-align: middle;
      line-height: 1;
    }
  }

  .LanguageSwitcher__ListItem:hover {
    background: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
  }

  .LanguageSwitcher__ListItem:hover > a {
    color: ${({ theme }) => theme.webMktNewPalette.white};
  }
`
